import Decimal from "decimal.js";
export const mergeColumns = (
  worksheet,
  outputSheet,
  rules,
  rule,
  fileSettings,
  inputColumns,
  outputColumns,
) => {
  // Treat an unset header row ("") as "no header", i.e. row 0, so data starts at row 1.
  const headerRow = Number(fileSettings.headerRow) || 0;

  if (rule.mergeDestination === "inputFile") {
    return processMerge(worksheet, rule, headerRow + 1, headerRow + 1);
  } else if (rule.mergeDestination === "outputFile") {
    // outputSheet's header is always written to row 1 (see helpers.js addColumnHeader),
    // independent of the input file's headerRow setting, so data always starts at row 2.
    return processMerge(outputSheet, rule, 2, 2);
  }
};

// A cell value counts as "present" only if it's a finite number, or a numeric string/boolean
// Decimal.js can parse. Anything else (missing cell, formula object, text, date) is not usable.
const toNumericValueOrNull = (value) => {
  if (value === undefined || value === null || value === "") return null;
  try {
    return new Decimal(value);
  } catch {
    return null;
  }
};

// Renders any cell value (including ExcelJS formula-result objects and Dates) as plain text.
const describeValue = (value) => {
  if (value === undefined || value === null || value === "") return "";
  if (value instanceof Date) return value.toISOString();
  if (typeof value === "object") return String(value.result ?? JSON.stringify(value));
  return String(value);
};

const processMerge = (sheet, rule, startRow, headerRow) => {
  const columnsData = rule.inputColumns.map(
    (colName) => sheet.getColumn(colName).values.slice(headerRow), // Always ignore header
  );
  const rowCount = Math.max(0, ...columnsData.map((col) => col.length));

  const emptyCounts = rule.inputColumns.reduce((acc, colName) => {
    acc[colName] = 0;
    return acc;
  }, {});
  const invalidValues = [];
  const rowsLog = [];

  for (let index = 0; index < rowCount; index++) {
    let sum = new Decimal(0);
    let foundAny = false;
    const rowValues = {};

    rule.inputColumns.forEach((colName, i) => {
      const rawValue = columnsData[i][index];
      rowValues[colName] = describeValue(rawValue);
      const numericValue = toNumericValueOrNull(rawValue);

      if (numericValue === null) {
        if (rawValue === undefined || rawValue === null || rawValue === "") {
          emptyCounts[colName] += 1;
        } else {
          invalidValues.push({
            column: colName,
            row: startRow + index,
            value: describeValue(rawValue),
          });
        }
        return;
      }

      sum = sum.plus(numericValue);
      foundAny = true;
    });

    const result = foundAny ? sum.toNumber() : null;
    rowsLog.push({ row: startRow + index, values: rowValues, result });

    if (foundAny) {
      sheet.getCell(`${rule.mergeTo}${startRow + index}`).value = result;
    }
  }

  return {
    data: undefined,
    trackingInfo: {
      mergeTo: rule.mergeTo,
      mergeDestination: rule.mergeDestination,
      inputColumns: rule.inputColumns,
      totalRows: rowsLog.length,
      rows: rowsLog,
      emptyCounts,
      invalidValues,
    },
  };
};
